<div
    id="app"
    class="authenticated-layout"
    [class.with-debug-bar]="!debugBar()?.hidden()"
    [class.menu-collapsed]="menuCollapsed"
    [class.notif-opened]="notificationsIsOpened"
    [class.has-unread-notifications]="notificationsHasUnread$ | async">

    <nav
        id="menu"
        layout-menu
        (action)="handleAction($event, 'menu')"
        [currentUser]="currentUser$ | async"
        [hasImportHistoryClearanceLevel]="hasImportHistoryClearanceLevel | async"
        [hasManualImportClearanceLevel]="hasManualImportClearanceLevel$ | async"
        [hasTeamFollowUpClearanceLevel]="hasTeamFollowUpClearanceLevel$ | async"
        [hasAdministrationToolsClearanceLevel]="hasAdministrationToolsClearanceLevel$ | async"
        [hasSuperAdministrationClearanceLevel]="hasSuperAdministrationClearanceLevel$ | async"
        [hasReadOnlyAccessToAllSuperDebtorsClearanceLevel]="hasReadOnlyAccessToAllSuperDebtorsClearanceLevel$ | async">
    </nav>

    <section id="content">
        <header id="top-bar" layout-top-bar
                [user]="currentUserAvatar$ | async"
                [userInfos]="userPopoverContent$ | async"
                [currentLanguage]="currentLanguage$ | async"
                [tenantName]="pageOverTitle$ | async"
                [tenantLogo]="pageOverLogo$ | async"
                (selectLanguage)="selectLanguage($event)" (logout)="logout()"
                (action)="handleAction($event)">
        </header>

        <main id="main" [class.overlay]="notificationsIsOpened" scrolledByContainer>
            <layout-breadcrumb/>
            <router-outlet/>
        </main>

        <side-panel
            (clickOutside)="closePanels()"
            exclude="#top-bar .btn-notifications, #top-bar"
            [open]="notificationsIsOpened || themesIsOpened">

            @if (notificationsIsOpened) {
                <notifications-panel
                    id="notifications"
                    class="notifications"
                    (action)="handleAction($event, 'notifications')"/>
            }

            @if (themesIsOpened) {
                <div class="theme-switcher-panel">
                    <h2 class="m-3" translate="App.Themes.Title"></h2>
                    <theme-switcher (selectTheme)="useTheme($event)"/>
                </div>
            }
        </side-panel>
    </section>

    <section class="app-wide-sidepanel" [class.open]="isAIChatOpen$ | async">
        <div class="sidepanel-resize-handle" (mousedown)="startSidepanelResize($event)"></div>
        @if (isAIChatOpenOnce$ | async) {
            <ai-chat-box [insight]="isAvaInsightEnabled$ | async" />
        }
    </section>
</div>

@if ((isAIChatOpen$ | async) === false) {
    <debug-bar/>
}
